import { Divider } from 'antd';
import { Icon } from '../../icon/icon';
import ButtonPrimaryMedium from '../ButtonPrimary/ButtonPrimaryMedium';
import ButtonSecondaryMedium from '../ButtonSecondary/ButtonSecondaryMedium';
import { openModal } from './openModal';

/**
 * Modal xác nhận một thao tác (cùng kiểu openModalConfirmFitHeight): tiêu đề có icon, nội dung giữa hai đường kẻ,
 * nút Hủy và nút đồng ý ở chân.
 * @param {Object} config
 * @param {string} config.title
 * @param {string} config.description
 * @param {string} config.okText
 * @param {string} config.cancelText
 * @param {Function} config.onOk Chạy sau khi modal đã đóng
 * @param {JSX.Element} [config.icon] Mặc định icon thông tin màu xanh
 */
export const openModalConfirm = ({
  title,
  description,
  okText,
  cancelText,
  onOk,
  icon,
}) => {
  const modal = openModal({
    title: (
      <div className="flex items-start justify-start gap-12 self-stretch grow">
        <span className="flex w-32 h-32" style={{ color: '#258FD2' }}>
          {icon ?? <Icon.ICInfo />}
        </span>
        <span className="text-title-medium emphasized">{title}</span>
      </div>
    ),
    content: (
      <>
        <Divider type="horizontal" className="m-0 !p-0" />
        <div className="p-16 gap-8 flex items-center justify-start flex-col m-0">
          <span className="text-body-medium text-start self-stretch">
            {description}
          </span>
        </div>
        <Divider type="horizontal" className="m-0 !p-0" />
      </>
    ),
    centered: true,
    width: 538,
    // Cao hơn Drawer/Modal mặc định (1000): modal này mở từ bên trong drawer, nếu không mask của drawer phủ lên và chặn click
    zIndex: 1100,
    classNames: {
      header: '!px-16 !py-12 gap-12 !m-0',
      body: '!p-0 !m-0 self-stretch',
      iconClose: 'absolute top-12 right-16',
      footer: '!px-16 !py-12 !gap-16 !items-end !flex !justify-end !m-0',
    },
    footer: (
      <>
        <ButtonSecondaryMedium
          title={cancelText}
          onClick={() => modal.destroy()}
        />
        <ButtonPrimaryMedium
          title={okText}
          onClick={() => {
            modal.destroy();
            onOk?.();
          }}
        />
      </>
    ),
  });
  return modal;
};
